/**
 * GA4 product event helper
 *
 * Depends on global product_handle_map / product_handle_valueMap from theme.js.
 *
 * Usage:
 *   data-product-data="{{variant.sku }}::{{ product.handle }}-{{ variant.options | join:'-' }}::{{ forloop.index0 }}::{{ product.handle }}::{{ section.settings.ga4_item_list_id }}::{{ product.handle }}::{{ variant.option1 }}::{% if variant.option2 != blank %}{{ variant.option2 }}{% else %}No{% endif %}::{{ product.title }}::{{ variant.price | money }}::1::£"
 *   
 *   var productItem = element.getAttribute('data-product-data').split('::');
 *   pushProductGa4Event(productItem, 'Product link', 'select_item', 0);
 *
 *   watchProductListGa4Event(root, '.pdp-ymal__card');
 *
 */
(function (window) {
  "use strict";

  function ensureDataLayer() {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
  }

  function getProductMetadata(productId) {
    var metadata = {
      item_name: "",
      item_variant: "",
      item_category: "",
      item_category2: "Standard",
    };

    if (
      typeof product_handle_map !== "undefined" &&
      product_handle_map.has(productId) &&
      typeof product_handle_valueMap !== "undefined"
    ) {
      var values = product_handle_valueMap[productId];
      metadata.item_name = values[0];
      metadata.item_variant = values[1];
      metadata.item_category = values[2];
      metadata.item_category2 = values[3];
    }

    return metadata;
  }

  function parsePrice(priceText) {
    return Number(String(priceText || "").replace(/[,£円]/g, ""));
  }

  function normalizeCategory3(variantTitle) {
    return String(variantTitle || "").replace("Default Title", "none");
  }

  function buildGa4Item(productItem, metadata, discount) {
    return {
      item_id: productItem[0],
      item_name: metadata.item_name,
      index: 1,
      item_list_id: productItem[4],
      item_list_name: productItem[4],
      item_category: metadata.item_category,
      item_category2: metadata.item_category2,
      item_category3: normalizeCategory3(productItem[6]),
      item_variant: metadata.item_variant,
      item_brand: "SHOKZ",
      price: parsePrice(productItem[9]),
      quantity: Number(productItem[10]),
      currency: "GBP",
      discount: discount,
    };
  }

  function pushProductGa4Event(productItem, buttonName, eventName, discount) {
    if (!productItem || !productItem.length) return;

    var resolvedDiscount = discount || 0;
    var metadata = getProductMetadata(productItem[0]);

    ensureDataLayer();
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: eventName,
      event_parameters: {
        item_list_id: productItem[4],
        item_list_name: productItem[4],
        currency: "GBP",
        button_name: buttonName,
        items: [buildGa4Item(productItem, metadata, resolvedDiscount)],
      },
    });
  }

  function pushProductListGa4Event(productItems) {
    if (!productItems || !productItems.length) return;

    var items = [];
    productItems.forEach(function (productItem) {
      if (!productItem || !productItem.length) return;
      var metadata = getProductMetadata(productItem[0]);
      var item = buildGa4Item(productItem, metadata, 0);
      var index = Number(productItem[2]);
      item.index = isNaN(index) ? items.length + 1 : index + 1;
      delete item.discount;
      items.push(item);
    });
    if (!items.length) return;

    ensureDataLayer();
    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: "ga4Event",
      event_name: "view_item_list",
      event_parameters: {
        currency: "GBP",
        item_list_id: items[0].item_list_id,
        item_list_name: items[0].item_list_name,
        items: items,
      },
    });
  }

  var listWatches = [];

  function isListInView(root) {
    if (window.getComputedStyle(root).display === "none" || root.offsetWidth === 0) return false;
    var rect = root.getBoundingClientRect();
    var viewHeight = window.innerHeight || document.documentElement.clientHeight;
    var visibleHeight = Math.min(rect.bottom, viewHeight) - Math.max(rect.top, 0);
    return rect.height > 0 && visibleHeight / rect.height >= 0.33;
  }

  function collectProductItems(root, cardSelector) {
    var productItems = [];
    root.querySelectorAll(cardSelector).forEach(function (card) {
      if (card.dataset.productData) productItems.push(card.dataset.productData.split("::"));
    });
    return productItems;
  }

  function watchProductListGa4Event(root, cardSelector) {
    if (!root || root._ga4ListWatch) return;
    cardSelector = cardSelector || "[data-product-data]";

    var resizeObserver = null;
    var attrObserver = null;

    function cleanup() {
      window.removeEventListener("scroll", tryTrack);
      if (resizeObserver) resizeObserver.disconnect();
      if (attrObserver) attrObserver.disconnect();
      listWatches = listWatches.filter(function (watch) {
        return watch !== tryTrack;
      });
    }

    function tryTrack() {
      if (root._ga4ListTracked) {
        cleanup();
        return;
      }
      if (!isListInView(root)) return;
      var productItems = collectProductItems(root, cardSelector);
      if (!productItems.length) return;
      root._ga4ListTracked = true;
      pushProductListGa4Event(productItems);
      cleanup();
    }

    root._ga4ListWatch = true;
    listWatches.push(tryTrack);
    window.addEventListener("scroll", tryTrack, { passive: true });

    if (window.ResizeObserver) {
      resizeObserver = new ResizeObserver(tryTrack);
      resizeObserver.observe(root);
    }

    attrObserver = new MutationObserver(tryTrack);
    attrObserver.observe(root, { attributes: true, attributeFilter: ["style", "class"] });

    if (!window.__ga4ListStyleWatch) {
      window.__ga4ListStyleWatch = true;
      new MutationObserver(function (mutations) {
        var injected = false;
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (node.nodeType === 1 && (node.tagName === "STYLE" || node.tagName === "LINK")) injected = true;
          });
        });
        if (!injected) return;
        listWatches.slice().forEach(function (watch) {
          watch();
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }

    tryTrack();
  }

  window.pushProductGa4Event = pushProductGa4Event;
  window.pushProductListGa4Event = pushProductListGa4Event;
  window.watchProductListGa4Event = watchProductListGa4Event;
})(window);
